export const LOCAL_STORAGE_KEY = {
  LAST_LOGIN_PROVIDER: 'LAST_LOGIN_PROVIDER', // 前回のログインプロバイダー
} as const;
